import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";

class OrderSelectionModal extends Component {
  render() {
    const { show, onClose, onPickUp, onOrder } = this.props;

    return (
      <Modal show={show} onHide={onClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Select Job Type</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ textAlign: "center" }}>
          <Button onClick={onPickUp} style={{ marginRight: "10px" }}>
            Pick From Another Store
          </Button>

          <Button onClick={onOrder}>Medicine Delivery</Button>
        </Modal.Body>
      </Modal>
    );
  }
}

export default OrderSelectionModal;
